<template>
    <div class="center">
        <button class="botonRestar" @click="restar()" :disabled="Disabled">-</button>
        <input class="inputNumber" v-model="Cantidad" @input="onInput()" @blur="validar()" :disabled="Disabled">         
        <button class="botonSumar" @click="sumar()" :disabled="Disabled">+</button>
    </div>    
</template>
<script>

export default {
  name: 'InputNumber',
  props: {
    Cantidad:String,
    AdmiteDecimales:String,
    Minimo:String,
    Disabled:Boolean
  },
  components: {},
  data() {
    return {
      
      old_cantidad:this.Minimo,
      admiteDecimales:this.AdmiteDecimales,
      minimo: this.Minimo,
    }
  },
  methods:
  {
    sumar(){
        let sum = this.admiteDecimales != 'N'? 0.1 : 1;
        let cantidadAux = this.admiteDecimales != 'N'? parseFloat(this.Cantidad):parseInt(this.Cantidad);
        let suma = this.admiteDecimales != 'N'?(sum + cantidadAux).toFixed(1):sum + cantidadAux;

        this.old_cantidad = this.Cantidad;
        this.Cantidad = suma.toString();
        
        this.cambio();
    },
    restar(){
        let minus = this.admiteDecimales != 'N'? 0.1 : 1;

        let cantidadAux = this.admiteDecimales != 'N'? parseFloat(this.Cantidad):parseInt(this.Cantidad);
        let resta = this.admiteDecimales != 'N'?(cantidadAux - minus).toFixed(1):cantidadAux - minus;

        let min = this.admiteDecimales != 'N'?parseFloat(this.minimo).toFixed(1):this.minimo;
        if(resta>=min){
            this.old_cantidad = this.Cantidad;
            this.Cantidad = resta.toString();
            
            this.cambio();
        }
    },
    onInput(){       

        if(this.admiteDecimales!='N'){
            //Corregimos la entrada
            if(this.Cantidad== "" || this.Cantidad ==".")
                this.Cantidad=this.minimo;
            
        }else if(this.Cantidad.length == 0){
            this.Cantidad =this.minimo;
        }

        var regExp = this.admiteDecimales=='N'? /^([0-9]+)$/ : /^([0-9]+\.?[0-9]?)$/;

        var matches = regExp.exec(this.Cantidad);

        
        if (!matches) {
            this.Cantidad = this.old_cantidad;
        } else{
            // let auxOld = this.old_cantidad;

            // if(this.old_cantidad[this.old_cantidad.length-1]== "."){
            //     auxOld = this.old_cantidad + this.minimo[this.minimo.length-1];
            //     auxOld = auxOld ==this.minimo? auxOld:this.old_cantidad+"0";
            // }
            this.cambio();
            this.old_cantidad = this.Cantidad;
        }
            
        
    },
    validar(){
        if(this.Cantidad[this.Cantidad.length-1]== ".")
            this.Cantidad = this.Cantidad + this.minimo[this.minimo.length-1];
        
        if(this.admiteDecimales != "N" && !this.Cantidad.includes(".")){
            let aux = this.Cantidad+".0";
            if(parseInt(aux)>0)
                this.Cantidad = aux;
            else
                this.Cantidad = this.Cantidad + "." + this.minimo[this.minimo.length-1];
        }
            

        if(this.old_cantidad[this.old_cantidad.length-1]== "."){
           let aux = (this.old_cantidad + this.minimo[this.minimo.length-1]);
           this.old_cantidad = aux ==this.minimo? aux:this.old_cantidad +"0";
           
        }

        if(this.Cantidad<= this.minimo)
            this.Cantidad = this.minimo;
            
        this.cambio();
    },   
    cambio(){
        this.$emit('cambio', this.Cantidad,this.old_cantidad)
    } 
    },
  }
</script>

<style>
.botonRestar{
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;    
    margin-right: 0px!important;  
    width: 25% !important;
    height: 100%;
    background: var(--main-color) !important;
    border-color: #66b1ff !important;
    color: #fff !important;
    cursor: pointer;
    line-height: 1;
    white-space: nowrap;
    border: 1px solid var(--main-color) ;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    font-size: 14px;
    float:left;
}
.botonSumar{
    margin-top: 0px !important;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important; 
    width: 25% !important;
    height: 100% !important;
    background: var(--main-color) !important;
    border-color: #66b1ff !important;
    color: #fff !important;
    cursor: pointer;
    line-height: 1;
    white-space: nowrap;
    border: 1px solid var(--main-color) ;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    font-size: 14px;
    float:left;
}
.inputNumber{
    background-color: #FFF;
    background-image: none;
    border: 1px solid #DCDFE6 !important;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    font-size: 80%;
    height: 100%;
    width:50%;
    line-height: 24px;    
    outline: 0;
    padding: 0 5px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1); 
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    float:left;
} 
.center{
    height:26px;
    width:98px;
    position: relative;
}
</style>

<style scoped>
.botonSumar{
margin-top: 0px !important;
}

</style>

